import type { BookingSessionBundle } from '@VelocitySquared/sunny16-content-dataobjects-cady/booking'

import { basicPlusDetailModalFallback } from '@/content/sessionCatalogBundles/sessionDetailModalFallbacks'

export const basicPlusBundleFallback: BookingSessionBundle = {
  internalName: 'Bundle: Basic Plus',
  identifier: '',
  title: 'Basic Plus',
  tagline: '',
  features: '',
  highlightedFeatures: '',
  listingImage: { assetId: '', alt: '', width: 0, height: 0, url: '' },
  listingImageMobile: { assetId: '', alt: '', width: 0, height: 0, url: '' },
  badgeLabel: '',
  ctaLabel: '',
  priceLabel: '',
  showPrice: true,
  selectLabel: '',
  recommendedLabel: '',
  galleryLabel: '',
  detailsLabel: '',
  detailPageSlug: '',
  includedScenesLabel: '',
  cartSummaryFeatures: '',
  featureBulletItems: [] as never,
  comparisonItems: [] as never,
  galleryImages: [] as never,
  upgradeModal: null,
  sessionsListingUpgradeModal: null,
  sceneSelectionPage: null,
  addOnsSelectionPage: null,
  detailPage: null,
  sessionDetailModal: basicPlusDetailModalFallback,
  valueDetails: {
    internalName: '',
    restricted: false,
    restrictedWarningText: '',
    restrictedWarningCheckboxLabel: '',
    selectionAlertText: '',
    trending: false,
    trendingLabel: '',
    creditBadgeLabel: '',
    promoText: '',
    promoHighlight: ''
  }
} as unknown as BookingSessionBundle
